var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"image-background",style:({
      backgroundImage: 'url(' + _vm.introduction.imageUrl + ')'
    })},[_c('h3',{staticClass:"is-size-3"},[_c('b',[_vm._v(_vm._s(_vm.introduction.title))])])]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.introduction.rules)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }